import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import {
  DataBlocks,
  Link,
  Status,
} from 'components';
import { pathOr } from 'ramda';
import { openValidationPDPopup } from '../../actions';
import styles from './styles.pcss';
const cx = classNames.bind(styles);

const ValidationPDStatus = (props) => {
  const {
    isShowStatus,
    isOnlineValidation,
    isSuccessSended,

    statusText,
    successText,
    texts,

    actions,
  } = props;

  if (!isShowStatus) return null;

  if (isSuccessSended) {
    return (
      <DataBlocks.Block className={cx('successWrapper')}>
        <Status className={['success', cx('statusSuccess')]}>
          <div className={cx('successText')} dangerouslySetInnerHTML={{ __html: successText }} />
        </Status>
      </DataBlocks.Block>
    );
  }

  return (
    <DataBlocks.Block className={cx('wrapper')}>
      <div dangerouslySetInnerHTML={{ __html: statusText }} />
      {isOnlineValidation && (
        <Link onClick={actions.openValidationPDPopup}>
          <span dangerouslySetInnerHTML={{ __html: texts.compareDataStatusLink }} />
        </Link>
      )}
    </DataBlocks.Block>
  );
};

ValidationPDStatus.propTypes = {
  isShowStatus: PropTypes.bool,
  isOnlineValidation: PropTypes.bool,
  isSuccessSended: PropTypes.bool,
  statusText: PropTypes.string,
  successText: PropTypes.string,
  texts: PropTypes.shape({
    compareDataStatusLink: PropTypes.string,
  }),
  actions: PropTypes.shape({
    openValidationPDPopup: PropTypes.func,
  }),
};

const mapStateToProps = (state) => {
  const home = pathOr({}, ['home'], state);
  const passportVD = pathOr({}, ['convergence', 'data', 'passportVD'], home);

  return {
    isShowStatus: passportVD.needShowVerificationBlock,
    isOnlineValidation: passportVD.verificationIsAvailable,
    statusText: passportVD.pdVerificationText,
    texts: passportVD.texts,

    isSuccessSended: home.validationPDRequestStatus === 'success',
    successText: home.validationPDSuccessText,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    openValidationPDPopup,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ValidationPDStatus);
